import React, { useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { Form } from "react-bootstrap";

function Phone_Number_Login() {
  const [phone, setPhone] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  return (
    <>
      {/* Phone */}
      <div className="form-group field_holder">
        <Form.Label>
          <img
            src="/assets/images/icons/phone.png"
            alt="icon"
            className="login_lable_icons"
          />
          Phone number
        </Form.Label>

        <PhoneInput
          country={"in"}
          value={phone}
          onChange={setPhone}
          inputClass="custom-phone-input"
          containerClass="custom-phone-container"
          buttonClass="custom-phone-button"
        />
      </div>

      {/* Password */}
      <div className="form-group field_holder">
        <Form.Label>
          <img
            src="/assets/images/icons/lock.png"
            alt="icon"
            className="login_lable_icons"
          />
          Password
        </Form.Label>

        <div className="password_input">
          <Form.Control
            type={showPassword ? "text" : "password"}
            placeholder="Password"
          />
          <span
            className="eye-icon"
            onClick={() => setShowPassword(!showPassword)}
          >
            {showPassword ? <FaEye /> : <FaEyeSlash />}
          </span>
        </div>
      </div>

     
    </>
  );
}

export default Phone_Number_Login;